import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "site-widget"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = { class: "tiles-container" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "text accent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWidget = _resolveComponent("HeaderWidget")!
  const _component_Tile = _resolveComponent("Tile")!
  const _component_ElevatedCard = _resolveComponent("ElevatedCard")!

  return (_openBlock(), _createBlock(_component_ElevatedCard, { widthType: 'third' }, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderWidget, {
        iconUrl: _ctx.loadIcon,
        title: _ctx.widget.libelle,
        "mode-edition": true,
        onFiltre: _ctx.filtre,
        onDupliquer: _ctx.dupliquer,
        onSuppression: _ctx.suppression
      }, null, 8, ["iconUrl", "title", "onFiltre", "onDupliquer", "onSuppression"]),
      _createElementVNode("div", null, [
        (_ctx.widget.sites == null || _ctx.widget.sites.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('multisites')), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.widget.sites, (site) => {
              return (_openBlock(), _createElementBlock("span", {
                key: site.id,
                class: "site-widget"
              }, [
                _createTextVNode(_toDisplayString(site.description) + " ", 1),
                (site.id !== _ctx.widget.sites[_ctx.widget.sites.length - 1].id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, ", "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Tile, {
            class: "tile",
            value: 2,
            titleNotBold: _ctx.$tc('widgetBilling.facture', 2),
            titleInBold: _ctx.$t('widgetBilling.retard'),
            titleEnd: _ctx.$t('widgetBilling.paiement'),
            color: '--edition-clair',
            fontSize: '19px',
            "is-loading": false
          }, null, 8, ["titleNotBold", "titleInBold", "titleEnd"]),
          _createVNode(_component_Tile, {
            class: "tile",
            value: 1,
            titleNotBold: _ctx.$tc('widgetBilling.facture', 1),
            titleInBold: _ctx.$t('widgetBilling.attente'),
            titleEnd: _ctx.$t('widgetBilling.paiement'),
            color: '--edition-medium',
            fontSize: '19px',
            "is-loading": false
          }, null, 8, ["titleNotBold", "titleInBold", "titleEnd"]),
          _createVNode(_component_Tile, {
            class: "tile",
            value: 5,
            titleNotBold: _ctx.$tc('widgetBilling.facture', 5),
            titleInBold: _ctx.$t('widgetBilling.payees'),
            color: '--edition-fonce',
            fontSize: '19px',
            "is-loading": false
          }, null, 8, ["titleNotBold", "titleInBold"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t('widgetBilling.jourEnRetard')) + " ", 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$tc('widgetBilling.nbJourEnRetard', 2)), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}